export const InventoryType = {
    AGRICULTURAL_INPUTS: 'AGRICULTURAL_INPUTS',
    GRAIN: 'GRAIN',
    FERTILIZER: 'FERTILIZER',
    SEED: 'SEED',
    OTHER: 'OTHER',
} as const satisfies Record<string, string>;

export type InventoryType = typeof InventoryType[keyof typeof InventoryType];

export const LegalRegime = {
    AF: 'AF',
    PLEDGE: 'PLEDGE',
    MORTGAGE: 'MORTGAGE',
    FIDUCIARY_ASSIGNMENT: 'FIDUCIARY_ASSIGNMENT',
} as const satisfies Record<string, string>;

export type LegalRegime = typeof LegalRegime[keyof typeof LegalRegime];

export interface InventoryOwner {
    personId: string;
    name: string;
    document: string;
}

export interface InventoryCustody {
    address: string | null;
    city: string | null;
    state: string | null;
}

export interface InventoryObligation {
    creditOperationId: string;
    allocatedPercentage: number | null;
    status: string;
    statusFormatted?: string;
}

export interface InventoryListItem {
    id: string;
    name: string;
    description: string | null;
    inventoryType: InventoryType;
    inventoryTypeFormatted: string;
    quantityDescription: string | null;
    legalRegime: LegalRegime | null;
    legalRegimeFormatted: string;
    certifiedValue: number | null;
    custodyCity: string | null;
    custodyState: string | null;
    trusteeName: string | null;
    archived: boolean;
    discharged: boolean;
    statusFormatted: string;
    createdAt: string;
    updatedAt: string;
}

export interface InventoryDetail {
    id: string;
    name: string;
    description: string | null;
    inventoryType: InventoryType;
    inventoryTypeFormatted: string;
    legalRegime: LegalRegime | null;
    legalRegimeFormatted: string;
    quantityDescription: string | null;
    custody: InventoryCustody;
    registrationNumber: string | null;
    registryOffice: string | null;
    registryState: string | null;
    trusteeName: string | null;
    trusteeDocument: string | null;
    certificateId: string | null;
    certificateDate: string | null;
    certifiedValue: number | null;
    owners: InventoryOwner[];
    obligations: InventoryObligation[];
    archived: boolean;
    comments: string | null;
    discharged: boolean;
    dischargeDate: string | null;
    dischargeValue: number | null;
    statusFormatted: string;
    createdAt: string;
    updatedAt: string;
}

export const INVENTORY_TYPE_OPTIONS = [
    { value: InventoryType.AGRICULTURAL_INPUTS, label: 'Insumos agrícolas' },
    { value: InventoryType.GRAIN, label: 'Grãos' },
    { value: InventoryType.FERTILIZER, label: 'Fertilizante' },
    { value: InventoryType.SEED, label: 'Semente' },
    { value: InventoryType.OTHER, label: 'Outro' },
];

export const LEGAL_REGIME_OPTIONS = [
    { value: LegalRegime.AF, label: 'Alienação Fiduciária' },
    { value: LegalRegime.PLEDGE, label: 'Penhor' },
    { value: LegalRegime.MORTGAGE, label: 'Hipoteca' },
    { value: LegalRegime.FIDUCIARY_ASSIGNMENT, label: 'Cessão Fiduciária' },
];

export const MAX_OWNERS = 20;
